import basicContentStyles from './basic-content';
